import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f1127110"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chose-order-box"
};
const _hoisted_2 = {
  class: "chose-order-tit"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "选择要抽免单的订单", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "每天有1次抽奖机会哦", -1));
const _hoisted_5 = {
  class: "order-list",
  ref: "scrollContainer"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "render-line-clamp tit"
};
const _hoisted_10 = {
  class: "order"
};
const _hoisted_11 = {
  class: "price"
};
const _hoisted_12 = {
  class: "num"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实付", -1));
const _hoisted_14 = {
  class: "order-btn-box"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    class: "'popup-box'",
    show: $options.show_pop,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $options.show_pop = $event),
    onOpen: $options.open,
    round: "",
    position: "bottom",
    teleport: "body"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_list, {
      loading: $data.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = $event => $data.loading = $event),
      finished: $data.finished,
      onLoad: $options.onLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.orderList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "order-item",
          onClick: $event => $data.selected = index
        }, [_createElementVNode("img", {
          class: "icon",
          src: _ctx.$imgUrlFilter($data.selected == index ? 'https://p6.moimg.net/mdwxapp/category_month/category_month_index_selected.png' : 'https://p6.moimg.net/mdwxapp/category_month/category_month_index_unselected.png', 32)
        }, null, 8, _hoisted_7), _createVNode(_component_van_image, {
          class: "logo",
          src: _ctx.$imgUrlFilter(item.reward_img, 128)
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.reward_title), 1), _createElementVNode("div", _hoisted_10, "订单号：" + _toDisplayString(item.order_id), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, "￥" + _toDisplayString(item.order_amount), 1), _hoisted_13])], 8, _hoisted_6);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])], 512), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", {
      class: "order-btn",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.sub && $options.sub(...args))
    }, "确定抽免单")])])]),
    _: 1
  }, 8, ["show", "onOpen"]);
}